import { ArrowLeft } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FormBuilder from '../../components/FormBuilder';
import { apiRequest } from '../../services/api';

// Mevcut bir formu düzenlemek için tam sayfa editör
export default function FormEditPage({ updateForm }) {
  const { id } = useParams();
  const navigate = useNavigate();
  // Form detayı liste endpoint'inde değil; düzenleme için tam detayı ayrı endpoint'ten çekiyoruz
  // (liste yanıtı görsel seçim base64'lerini içermez, hızlı kalır)
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function loadForm() {
      try {
        setLoading(true);
        setError(null);
        const data = await apiRequest(`/api/forms/admin/${id}`);
        if (!cancelled) {
          setForm(data);
        }
      } catch (exception) {
        if (!cancelled) {
          setError(exception.message || 'Form yüklenemedi.');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }
    loadForm();
    return () => { cancelled = true; };
  }, [id]);

  async function saveEdit(payload) {
    const saved = await updateForm(id, payload);
    if (saved) {
      navigate('/admin/formlar');
    }
  }

  if (loading) {
    return (
      <section className="form-create-page">
        <div className="empty-state">Form yükleniyor...</div>
      </section>
    );
  }

  if (error || !form) {
    return (
      <section className="form-create-page">
        <div className="empty-state empty-state-stack">
          <span>{error || 'Form bulunamadı.'}</span>
          <button className="btn btn-light" onClick={() => navigate('/admin/formlar')}>
            <ArrowLeft size={15} /> Listeye dön
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="form-create-page">
      <div className="section-header">
        <div>
          <h2>{form.name}</h2>
          <p className="muted">
            Bölüm ve alanları güncelleyin. Kaydedilen değişiklikler bu formu dolduran tüm kullanıcılara anında yansır;
            daha önce gönderim yapılmış alanlar kaldırılamaz.
          </p>
        </div>
        <button className="btn btn-light" onClick={() => navigate('/admin/formlar')}>
          <ArrowLeft size={15} /> Listeye dön
        </button>
      </div>

      <div className="form-create-builder">
        <div className="form-create-builder-body">
          <FormBuilder initialForm={form} onSave={saveEdit} submitLabel="Değişiklikleri kaydet" />
        </div>
      </div>
    </section>
  );
}
